import type { FC, ReactNode } from 'react'

import Head from 'next/head'

import { contact, siteConfig } from '@/constants/site'

/*
 * LocalBusiness structured data for Czechmate Consulting. Every value here is
 * taken from the business's own website (legal notice, contact details,
 * opening hours and Facebook page).
 */
const schema = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': `${siteConfig.url}/#business`,
    name: siteConfig.name,
    url: siteConfig.url,
    description: siteConfig.description,
    image: `${siteConfig.assetsUrl ?? siteConfig.url}/images/czechmate/og-image.jpg`,
    logo: `${siteConfig.assetsUrl ?? siteConfig.url}/images/czechmate/logo-full.png`,
    telephone: '+1-503-850-8433',
    email: contact.email,
    address: {
        '@type': 'PostalAddress',
        streetAddress: contact.street,
        addressLocality: contact.city,
        addressRegion: contact.regionCode,
        postalCode: contact.postalCode,
        addressCountry: contact.country
    },
    geo: {
        '@type': 'GeoCoordinates',
        latitude: 44.0712449,
        longitude: -123.1084192
    },
    openingHoursSpecification: [
        {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday'],
            opens: '08:00',
            closes: '17:00'
        },
        {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: 'Thursday',
            opens: '07:00',
            closes: '17:00'
        },
        {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: 'Friday',
            opens: '09:00',
            closes: '16:00'
        }
    ],
    founder: {
        '@type': 'Person',
        name: 'Brad Chvatal',
        honorificPrefix: 'Dr.',
        jobTitle: 'Orthodontist and practice coach'
    },
    sameAs: [siteConfig.links?.facebook].filter(Boolean)
}

export const BusinessSchema: FC = (): ReactNode => {
    return (
        <Head>
            <script
                key='business-schema'
                type='application/ld+json'
                dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
            />
        </Head>
    )
}
